import { CHAPTER_BACKGROUND_LENIENT_SYNC_MS } from '@/constants/chapterBackgroundLenientSync'

export function isLenientBackgroundChapterSync(
  backup: { timestamp: number },
  now = Date.now(),
): boolean {
  return now - backup.timestamp <= CHAPTER_BACKGROUND_LENIENT_SYNC_MS
}
